import { CommonAPIService } from '/src/servicehandlers/CommonHandler';

export class VPNAPIService {
    constructor() {
        this.CommonAPIService = new CommonAPIService();
    }

    downloadVPNConfig(peerId, router, store){
        const url = `/api/devices/pr/vpn/peers/${peerId}/config`
        return this.CommonAPIService.getCall(url, null, router, store)
    }

    getPeers(router, store){
        const url = `/api/devices/pr/vpn/peers`
        return this.CommonAPIService.getCall(url, null, router, store)
    }

    addPeer(peer, router, store){
        const url = `/api/devices/pr/vpn/peers`
        return this.CommonAPIService.postCall(url, peer, router, store)
    }

    getPeersById(peerId, router, store){
        const url = `/api/devices/pr/vpn/peers/${peerId}`
        return this.CommonAPIService.putCall(url, null, router, store)
    }

    deletePeer(peerId, router, store){
        const url = `/api/devices/pr/vpn/peers/${peerId}`
        return this.CommonAPIService.deleteCall(url, null, router, store)
    }
}
export default VPNAPIService;